export enum BillingOption {
  MONTHLY = 'monthly',
  ANNUALLY = 'annually',
  LIFETIME = 'lifetime',
  QUARTERLY = 'quarterly',
}
